import { Outlet } from 'react-router-dom'
import Sidebar from './Sidebar'
import { useState } from 'react'

const Layout = () => {
  const [sidebarExpanded, setSidebarExpanded] = useState(true)

  console.log('Layout - sidebarExpanded:', sidebarExpanded)

  return (
    <div className="min-h-screen bg-gray-50">
      <Sidebar onExpandChange={setSidebarExpanded} />

      {/* Contenido principal */}
      <div className={`transition-all duration-300 ease-in-out ${sidebarExpanded ? 'lg:pl-64' : 'lg:pl-16'}`}>
        {/* Contenido de la página */}
        <main className="p-6">
          <Outlet />
        </main>
      </div>
    </div>
  )
}

export default Layout 